// swiper
const productBanner01 = require('common/ter/images/product_banner01.png')
const productBanner03 = require('common/ter/images/product_banner03.png')
const productBanner02 = require('common/ter/images/product_banner02.png')
const sj = require('common/ter/images/sj.jpg')
const qr365 = require('common/ter/images/qr-365.png')
// 产品动态
const mainProduct0 = require('common/ter/images/main_product.png')
const secondProduct = require('common/ter/images/second_product.png')

const data = {
  mainProduce: [
    {
      bakImg: productBanner01,
      title: '主内圣经',
      intro: '让在线读经变得更加丰富多彩',
      qrImg: sj,
      typeCt: [
        {
          name: 'Android端',
          typeLink: 'https://android.myapp.com/myapp/detail.htm?apkName=com.zhunei.biblevip&ADTAG=mobile'
        },
        {
          name: 'IOS端',
          typeLink: 'https://android.myapp.com/myapp/detail.htm?apkName=com.zhunei.biblevip&ADTAG=mobile'
        },
        {
          name: '在线阅读',
          typeLink: 'http://holy-bible.net/readBible.html'
        }
      ]
    },
    {
      bakImg: productBanner02,
      title: '福音广告',
      intro: '报福音、传福音的人，他们的脚踪何等佳美',
      qrImg: '#',
      typeCt: [
        {
          name: '联系体验',
          typeLink: null
        }
      ]
    },
    {
      bakImg: productBanner03,
      title: '恩典365',
      intro: '365天，一起活着神的爱和恩典里面',
      qrImg: qr365,
      typeCt: [
        {
          name: 'Android端',
          typeLink: 'https://android.myapp.com/myapp/detail.htm?apkName=com.zhunei.ed365&ADTAG=mobile'
        },
        {
          name: 'IOS端',
          typeLink: 'https://android.myapp.com/myapp/detail.htm?apkName=com.zhunei.ed365&ADTAG=mobile'
        }
      ]
    }
  ],
  produceActive: [
    {
      title: '主内圣经',
      img: mainProduct0,
      more: 'https://bible.com.cn/index.html',
      content: [
        {
          item: '新版本 v1.0.8 多本注释以及译本...',
          date: '2019-05-02'
        },
        {
          item: '新版本 v1.0.7 使用教程：如何切换圣经译...',
          date: '2019-05-01'
        },
        {
          item: '新版本 v1.0.6 多种新功能...',
          date: '2019-04-27'
        }
      ]
    },
    {
      title: '福音广告',
      img: secondProduct,
      more: null,
      content: [
        {
          item: '福音广告二期跟进端公测',
          date: '2019-05-13'
        },
        {
          item: '福音广告一期发布上线了',
          date: '2019-04-25'
        },
        {
          item: '线下活动完美收官',
          date: '2019-04-17'
        }
      ]
    }
  ]
}
export default data



// WEBPACK FOOTER //
// ./src/common/ter/js/produce.js